module.exports = __webpack_public_path__ + "img/grid-2.a7327e76.jpg";